const testimonials = [
  {
    name: "Dr. Sarah K.",
    location: "Gainesville, FL",
    rating: 5,
    text: "I'm a professor at UF and needed my passport renewed for a conference in Barcelona. I was worried about timing with the semester starting. Fast Passport Center handled everything — I shipped from the UPS Store near Butler Plaza and had my passport back in 7 days. Never had to leave Gainesville.",
    service: "Passport Renewal",
  },
  {
    name: "Marcus W.",
    location: "Ocala, FL",
    rating: 5,
    text: "My daughter was heading to Japan for a study abroad program through Santa Fe College. We live in Ocala and needed her first passport fast. FPC walked us through the whole process, told us exactly which clerk to visit in Gainesville, and expedited everything after. Passport came in 9 days.",
    service: "New Passport",
  },
  {
    name: "Jennifer L.",
    location: "Lake City, FL",
    rating: 5,
    text: "Lost my passport two weeks before a cruise out of Jacksonville. Living in Lake City, I thought I was in trouble with no passport office nearby. Called FPC and they got me a replacement in 6 days. Shipped overnight from Gainesville. Amazing service that saved our family vacation.",
    service: "Lost Passport",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function GainesvilleTestimonialsSection() {
  return (
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What North Central Florida Travelers Say
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from real travelers across Gainesville, Ocala, Lake City, and North Central Florida who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-[#F7F8FA] border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}